import React from "react";
import styles from "./city.module.scss";
import {useApiData} from "../../hooks/useApiData";
import {mergeData} from "../../utils/data-utils";
import {indexData} from "../../data/data-index";
import { useIsMobile } from "../../hooks/mobile.js";
import { scoreColumns } from '../../data/score-columns.js';
import { getNumberWithOrdinalWithSuperscript } from "../../hooks/utils.js";


export default function CityEmbed(props) {
  const { citySlug } = props;

  const {data, isLoading, error} = useApiData();
  const isMobile = useIsMobile();
  const ICON_SIZE = isMobile ? 30 : 36;


  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error: {error.message}</div>;

  const citiesData = mergeData(indexData, data);

  let city = null;
  // let cityData = null;

  if (citiesData) {
    city = citiesData.find((d) => d.country === citySlug);
  }


  return (
    <div className={styles.cityEmbed}>
      {citiesData && city &&
        <table className={styles.cityTable}>
          <thead>
            <tr className={styles.cityTableHead} key={city.country}>
              <th colSpan={4} >
                <div className="row align-items-end">
                  <div className="col">
                    <h2 className={styles.cityTableHeader}>
                      {getNumberWithOrdinalWithSuperscript(city.rank)}
                      {" " + city.country}
                    </h2>
                  </div>
                  <div className={`col text-right ${styles.totalScore}`}>
                    <span className={styles.cityTableHeaderScore}>Total opportunity score</span>
                    <h2 className={styles.cityTableHeaderH2}>
                      {city.total.toFixed(0)+'%'}
                    </h2>
                  </div>
                </div>
              </th>
              {/*<th colSpan={2} className={styles.totalScore}>*/}
              {/* */}
              {/*</th>*/}
            </tr>
          </thead>
          <tbody>
            {scoreColumns.map((d, index) => {
              return (
                <tr key={index}>
                  <td aria-hidden="true" className={styles.iconColumn}>
                    <img
                      src={"data:image/svg+xml," + encodeURIComponent(d.icon)}
                      alt={d.score}
                      className={styles.parameterIcon}
                      style={{ height: "auto", width: ICON_SIZE }}
                      aria-hidden="true"
                    />
                  </td>
                  <td className={styles.nameColumn}>{d.score_name}</td>
                  
                  <td aria-hidden="true" className={styles.barchartColumn}>
                    <div className={styles.barchartBackground}></div>
                    <div
                      className={styles.barchartForeground}
                      // style={{ width: `${(city[d.score_columns] / 10) * 100}%` }}
                      style={{ width: `${(city[d.score_columns] )}%` }}
                    ></div>
                    <div className={styles.barChartLabel}>{d.score_name}</div>
                  </td>
                  
                  <td className={styles.scoreColumn}>{city[d.score_columns].toFixed(0)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      }
    </div>
  );
}
